// extracted by mini-css-extract-plugin
export default {"icon":"ParcelHistory_icon__G7eum"};